import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './state/AuthContext';
import { PlantProvider } from './state/PlantContext';
import './styles/index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <PlantProvider>
          <App />
        </PlantProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
